import { Inject, Injectable, Injector, Optional } from '@angular/core';
import { ResolverConfig, RESOLVER_REGISTRY } from '../types';

@Injectable({ providedIn: 'root' })
export class ResolverRegistry {
  constructor(
    @Optional()
    @Inject(RESOLVER_REGISTRY)
    private resolvers: ResolverConfig[] | undefined,
    private injector: Injector
  ) {}

  public get(source: string): any {
    const resolver = this.resolvers?.find((item) => item.key === source);
    return resolver ? this.injector.get(resolver?.resolver) : undefined;
  }
}
